import React, { useContext } from "react";
import {
  swatchList, colorSwatch,
  selected, swatchLabel, swatchTitle, color
} from "./style.mod.scss";
import ProductContext from "services/product-context";
import { Link } from "gatsby";
import locale from "locales";

const ColorSwatch = (props) => {
  const { variants, currentVariant } = props;
  const { handle } = useContext(ProductContext);

  return <>
    <span className={swatchLabel}> <span className={swatchTitle}>{locale.products.color}</span>: </span>
    <div className={swatchList}> 
      {variants.map((variant) => <div
        key={variant.id}
        className={`${currentVariant.id === variant.id ? selected : color} `}>
        <Link to={`/products/${handle}/${variant.handle?.current}`} state={{ preserveScroll: true }}>
          <div className={colorSwatch} style={{ backgroundColor: variant.swatchColor?.hex }}> </div>
        </Link>
      </div>)} 
    </div>
  </>;
};

export default ColorSwatch;
